const WAV_HEADER_BYTES = 44
const BITS_PER_SAMPLE = 16
const BYTES_PER_SAMPLE = BITS_PER_SAMPLE / 8
const PCM_FORMAT = 1
const CHANNELS = 1

export const concatFloat32 = (chunks: Float32Array[]): Float32Array => {
  let totalLength = 0
  for (const chunk of chunks) totalLength += chunk.length
  const out = new Float32Array(totalLength)
  let offset = 0
  for (const chunk of chunks) {
    out.set(chunk, offset)
    offset += chunk.length
  }
  return out
}

const floatToInt16 = (input: Float32Array): Int16Array => {
  const out = new Int16Array(input.length)
  for (let i = 0; i < input.length; i++) {
    const s = input[i]
    if (s >= 1) out[i] = 32767
    else if (s <= -1) out[i] = -32768
    else out[i] = Math.round(s * 32767)
  }
  return out
}

const writeString = (view: DataView, offset: number, value: string) => {
  for (let i = 0; i < value.length; i++) view.setUint8(offset + i, value.charCodeAt(i))
}

const writeWavHeader = (view: DataView, dataLen: number, sampleRate: number) => {
  const byteRate = sampleRate * CHANNELS * BYTES_PER_SAMPLE
  const blockAlign = CHANNELS * BYTES_PER_SAMPLE

  writeString(view, 0, 'RIFF')
  view.setUint32(4, 36 + dataLen, true)
  writeString(view, 8, 'WAVE')
  writeString(view, 12, 'fmt ')
  view.setUint32(16, 16, true)
  view.setUint16(20, PCM_FORMAT, true)
  view.setUint16(22, CHANNELS, true)
  view.setUint32(24, sampleRate, true)
  view.setUint32(28, byteRate, true)
  view.setUint16(32, blockAlign, true)
  view.setUint16(34, BITS_PER_SAMPLE, true)
  writeString(view, 36, 'data')
  view.setUint32(40, dataLen, true)
}

export const encodeWav = (chunks: Float32Array[], sampleRate: number): Blob => {
  const samples = concatFloat32(chunks)
  const pcm = floatToInt16(samples)
  const dataLen = pcm.byteLength

  const buffer = new ArrayBuffer(WAV_HEADER_BYTES + dataLen)
  const view = new DataView(buffer)
  writeWavHeader(view, dataLen, sampleRate)
  new Int16Array(buffer, WAV_HEADER_BYTES).set(pcm)

  return new Blob([buffer], { type: 'audio/wav' })
}
